import { useSearchParams } from 'next/navigation';

export const useGuestPassRequestCode = () => {
	const searchParams = useSearchParams();
	return searchParams?.get('code') || undefined;
};
